import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00819dbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "font-grey p-cursor text-center" }, [
      /*#__PURE__*/_createElementVNode("b", { style: {"color":"#6B7A99"} }, "Shareholder Individual Application")
    ])
  ])
], -1))
const _hoisted_7 = { class: "row my-3 justify-content-center" }
const _hoisted_8 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_9 = { class: "container-fluid" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "list-unstyled multi-steps" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Personal", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Business", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "External Bank Account", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "E-Signature", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Upload Proof", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "row my-3 justify-content-center" }
const _hoisted_24 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_25 = { class: "login-card" }
const _hoisted_26 = { class: "login-body company" }
const _hoisted_27 = { class: "row mt-3" }
const _hoisted_28 = { class: "col-md-12 col-12" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Type of Individual Customer", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Individual", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Customer with joint account between a husband and wife with same address", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Customer with a joint account with different surnames but with the same address", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Customer with a joint account with different addresses", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Sole Trader", -1))
const _hoisted_37 = { class: "col-md-12 col-12" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Ref number by Caprock please enter it here.")
], -1))
const _hoisted_40 = { class: "col-md-12 col-12" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Advisor Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Advisor Ref number by Caprock please enter it here.")
], -1))
const _hoisted_43 = { class: "col-md-12 col-12" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Profile Picture", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = ["src"]
const _hoisted_48 = {
  key: 3,
  class: "progress"
}
const _hoisted_49 = ["aria-valuenow"]
const _hoisted_50 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full Name", -1))
const _hoisted_53 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Customer's Former Name(s):", -1))
const _hoisted_56 = {
  key: 2,
  class: "col-md-12 col-12"
}
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Residental Address", -1))
const _hoisted_59 = { class: "form-group place_suggestra d-none" }
const _hoisted_60 = {
  class: "card place_suggestra",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["id"]
const _hoisted_63 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_64 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_66 = {
  key: 3,
  class: "col-md-12 col-12"
}
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth", -1))
const _hoisted_69 = {
  key: 4,
  class: "col-md-12 col-12"
}
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "First Person Full Name", -1))
const _hoisted_72 = {
  key: 5,
  class: "col-md-12 col-12"
}
const _hoisted_73 = { class: "form-group" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "First Person's Former Name(s):", -1))
const _hoisted_75 = {
  key: 6,
  class: "col-md-12 col-12"
}
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "First Person's Residental Address", -1))
const _hoisted_78 = { class: "form-group place_suggestra1 d-none" }
const _hoisted_79 = {
  class: "card place_suggestra1",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["id"]
const _hoisted_82 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_83 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_85 = {
  key: 7,
  class: "col-md-12 col-12"
}
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "First Person's Date of Birth", -1))
const _hoisted_88 = {
  key: 8,
  class: "col-md-12 col-12"
}
const _hoisted_89 = { class: "form-group" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Second Person's Full Name", -1))
const _hoisted_91 = {
  key: 9,
  class: "col-md-12 col-12"
}
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Second Person's Customer's Former Name(s):", -1))
const _hoisted_94 = {
  key: 10,
  class: "col-md-12 col-12"
}
const _hoisted_95 = { class: "form-group" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Second Person's Residental Address", -1))
const _hoisted_97 = { class: "form-group place_suggestra1 d-none" }
const _hoisted_98 = {
  class: "card place_suggestra1",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_99 = ["onClick"]
const _hoisted_100 = ["id"]
const _hoisted_101 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_102 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_104 = {
  key: 11,
  class: "col-md-12 col-12"
}
const _hoisted_105 = { class: "form-group" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Second Person's Date of Birth", -1))
const _hoisted_107 = {
  key: 12,
  class: "col-md-12 col-12"
}
const _hoisted_108 = { class: "form-group" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Residental Address", -1))
const _hoisted_110 = { class: "form-group place_suggestra d-none" }
const _hoisted_111 = {
  class: "card place_suggestra",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_112 = ["onClick"]
const _hoisted_113 = ["id"]
const _hoisted_114 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_115 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_117 = { class: "col-md-12 col-12" }
const _hoisted_118 = { class: "form-group" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Investment Currency", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_121 = ["value"]
const _hoisted_122 = { class: "col-md-12 col-12" }
const _hoisted_123 = { class: "form-group" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Expected investment amount", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$500k-$50 million" }, "$500k-$50 million", -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$50-$100 million" }, "$50-$100 million", -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$100 million +" }, "$100 million +", -1))
const _hoisted_129 = { class: "col-md-12 col-12" }
const _hoisted_130 = { class: "form-group" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Applicant's country", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_133 = ["value"]
const _hoisted_134 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_135 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_136 = { class: "col-3 px-1" }
const _hoisted_137 = { class: "col-3 px-1" }
const _hoisted_138 = { class: "col-3 px-1" }
const _hoisted_139 = { class: "row my-3 justify-content-center" }
const _hoisted_140 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_141 = { class: "login-card" }
const _hoisted_142 = { class: "login-body business" }
const _hoisted_143 = { class: "row mt-3" }
const _hoisted_144 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_145 = { class: "form-group" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Individual Assesment Nature", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Foreign", -1))
const _hoisted_150 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_151 = { class: "form-group" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Business Name", -1))
const _hoisted_153 = {
  key: 2,
  class: "col-md-12 col-12"
}
const _hoisted_154 = { class: "form-group" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Address of principal place of business", -1))
const _hoisted_156 = { class: "form-group place_suggest_pr_a d-none" }
const _hoisted_157 = {
  class: "card place_suggest_pr_a",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_158 = ["onClick"]
const _hoisted_159 = ["id"]
const _hoisted_160 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_161 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_163 = {
  key: 3,
  class: "col-md-12 col-12"
}
const _hoisted_164 = { class: "form-group" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "ABN", -1))
const _hoisted_166 = {
  key: 4,
  class: "col-md-12 col-12"
}
const _hoisted_167 = { class: "form-group" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Are you a USA citizen?", -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "usa_citizen0"
}, " Yes ", -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "usa_citizen1"
}, " No ", -1))
const _hoisted_172 = {
  key: 5,
  class: "col-md-12 col-12"
}
const _hoisted_173 = { class: "form-group" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "If USA citizen or tax resident of USA is marked Yes, kindly provide social security number", -1))
const _hoisted_175 = {
  key: 6,
  class: "col-md-12 col-12"
}
const _hoisted_176 = { class: "form-group" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Are you a tax resident of the USA ?", -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "usa_tax_resident0"
}, " Yes ", -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "usa_tax_resident1"
}, " No ", -1))
const _hoisted_181 = {
  key: 7,
  class: "col-12"
}
const _hoisted_182 = { class: "form-group" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "If USA citizen and tax resident of USA is marked Yes, kindly provide your Tax ID", -1))
const _hoisted_184 = {
  key: 8,
  class: "col-md-12 col-12"
}
const _hoisted_185 = { class: "form-group" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Individual Assesment Nature for First Person", -1))
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian", -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Foreign", -1))
const _hoisted_190 = {
  key: 9,
  class: "col-md-12 col-12"
}
const _hoisted_191 = { class: "form-group" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Individual Assesment Nature for Second Person", -1))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian", -1))
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Foreign", -1))
const _hoisted_196 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_197 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_198 = { class: "col-3 px-1" }
const _hoisted_199 = { class: "col-3 px-1" }
const _hoisted_200 = { class: "col-3 px-1" }
const _hoisted_201 = { class: "row my-3 justify-content-center" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-card" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "login-body company" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" })
    ])
  ])
], -1))
const _hoisted_203 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_204 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_205 = { class: "col-3 px-1" }
const _hoisted_206 = { class: "col-3 px-1" }
const _hoisted_207 = { class: "row my-3 justify-content-center" }
const _hoisted_208 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_209 = { class: "login-card" }
const _hoisted_210 = { class: "login-body company" }
const _hoisted_211 = { class: "row mt-3" }
const _hoisted_212 = { class: "col-md-12 col-12" }
const _hoisted_213 = { class: "form-group" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_215 = { class: "col-md-12 col-12" }
const _hoisted_216 = { class: "form-group" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_218 = { class: "col-md-12 col-12" }
const _hoisted_219 = { class: "form-group" }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_221 = { class: "col-md-12 col-12" }
const _hoisted_222 = { class: "form-group" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth", -1))
const _hoisted_224 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_225 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_226 = { class: "col-3 px-1" }
const _hoisted_227 = { class: "col-3 px-1" }
const _hoisted_228 = { class: "col-3 px-1" }
const _hoisted_229 = { class: "row my-3 justify-content-center" }
const _hoisted_230 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_231 = { class: "login-card" }
const _hoisted_232 = { class: "login-body company" }
const _hoisted_233 = { class: "row mt-3" }
const _hoisted_234 = { class: "form-group" }
const _hoisted_235 = { class: "font-grey" }
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_237 = ["onClick"]
const _hoisted_238 = ["innerHTML"]
const _hoisted_239 = {
  key: 3,
  class: "progress"
}
const _hoisted_240 = ["aria-valuenow"]
const _hoisted_241 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_242 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_243 = { class: "col-3 px-1" }
const _hoisted_244 = { class: "col-3 px-1" }
const _hoisted_245 = { class: "col-3 px-1" }
const _hoisted_246 = {
  class: "modal fade cancel_request",
  id: "cancel_request",
  role: "dialog"
}
const _hoisted_247 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_248 = { class: "modal-content" }
const _hoisted_249 = { class: "modal-body mb-2" }
const _hoisted_250 = { class: "row mx-1 mt-1" }
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Cancelling will delete all details entered.")
], -1))
const _hoisted_252 = { class: "col-md-12 text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Banks = _resolveComponent("Banks")!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.set_step(1);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='personal'}])
                      }, _hoisted_14, 2),
                      _createElementVNode("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.set_step(2);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='business'}])
                      }, _hoisted_16, 2),
                      _createElementVNode("li", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.set_step(3);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='account'}])
                      }, _hoisted_18, 2),
                      _createElementVNode("li", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.set_step(4);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='e_signature'}])
                      }, _hoisted_20, 2),
                      (_ctx.final_step==5)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.set_step(5);}),
                            class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='upload'}])
                          }, _hoisted_22, 2))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (this.current_step==1)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 0,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_1
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_Field, {
                                  modelValue: this.active_tab,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.active_tab) = $event)),
                                  name: "user_type",
                                  id: "user_type",
                                  type: "hidden"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _hoisted_30,
                                    _createVNode(_component_Field, {
                                      onChange: _cache[6] || (_cache[6] = ($event: any) => {_ctx.conditionChange();}),
                                      modelValue: _ctx.form.individual_customer_type,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.individual_customer_type) = $event)),
                                      class: "form-control",
                                      name: "individual_customer_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_31,
                                        _hoisted_32,
                                        _hoisted_33,
                                        _hoisted_34,
                                        _hoisted_35,
                                        _hoisted_36
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "individual_customer_type"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _hoisted_39,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.user_ref_no,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.user_ref_no) = $event)),
                                      placeholder: "ie. CM0011114",
                                      class: "form-control selected-field",
                                      name: "user_ref_no",
                                      id: "user_ref_no",
                                      type: "text"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "user_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _hoisted_42,
                                    _createVNode(_component_Field, {
                                      readonly: _ctx.advisor_exist ==1,
                                      modelValue: _ctx.form.advisor_ref_no,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.advisor_ref_no) = $event)),
                                      placeholder: "ie. A042",
                                      class: "form-control selected-field",
                                      name: "advisor_ref_no",
                                      id: "advisor_ref_no",
                                      type: "text"
                                    }, null, 8, ["readonly", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "advisor_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _hoisted_45,
                                    _hoisted_46,
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 0,
                                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file"
                                        }, null, 8, ["modelValue"]))
                                      : _createCommentVNode("", true),
                                    (typeof _ctx.records.profile_pic_url=='undefined' || _ctx.records.profile_pic_url=='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 1,
                                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic"
                                    }),
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "p-cursor",
                                          onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.openDoc(_ctx.records.profile_pic_url);})
                                        }, [
                                          _createElementVNode("img", {
                                            class: "rounded-circle",
                                            style: {"height":"50px"},
                                            src: _ctx.records.profile_pic_url
                                          }, null, 8, _hoisted_47)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.form['profile_pic_pdiv']==1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                          _createElementVNode("div", {
                                            class: "progress-bar bg-dark",
                                            role: "progressbar",
                                            style: _normalizeStyle({'width':_ctx.form['profile_pic_pbar']+'%'}),
                                            "aria-valuenow": _ctx.form['profile_pic_pbar'],
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }, _toDisplayString(_ctx.form['profile_pic_pbar_p']), 13, _hoisted_49)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_Field, {
                                      rules: _ctx.requiredField,
                                      modelValue: _ctx.form['profile_pic_path'],
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form['profile_pic_path']) = $event)),
                                      class: "form-control selected-field",
                                      name: "profile_pic_path",
                                      type: "hidden"
                                    }, null, 8, ["rules", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic_path"
                                    })
                                  ])
                                ]),
                                (_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, [
                                        _hoisted_52,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.full_name,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.full_name) = $event)),
                                          class: "form-control selected-field",
                                          name: "full_name",
                                          placeholder: "your full name here",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "full_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                      _createElementVNode("div", _hoisted_54, [
                                        _hoisted_55,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.customer_former_names,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.customer_former_names) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer_former_names",
                                          placeholder: "your former names here",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer_former_names"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _hoisted_58,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[18] || (_cache[18] = ($event: any) => {_ctx.textSearch($event,'ra');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.residental_address,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.residental_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "residental_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "residental_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'residental_address','ra');},
                                              class: "suggestDivra"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_62),
                                              _createElementVNode("h6", _hoisted_63, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_64, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_61))
                                          }), 128)),
                                          _hoisted_65
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                      _createElementVNode("div", _hoisted_67, [
                                        _hoisted_68,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.user_dob,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.user_dob) = $event)),
                                          class: "form-control selected-field",
                                          name: "user_dob",
                                          type: "date",
                                          rules: _ctx.requiredField,
                                          onclick: "this.type='date'",
                                          onfocus: "this.type='date';",
                                          onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                          placeholder: "D.O.B"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "user_dob"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3 || _ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                      _createElementVNode("div", _hoisted_70, [
                                        _hoisted_71,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.customer1_full_name,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.customer1_full_name) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer1_full_name",
                                          placeholder: "customer 1 name here",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer1_full_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3 || _ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                      _createElementVNode("div", _hoisted_73, [
                                        _hoisted_74,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.customer1_former_names,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.customer1_former_names) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer1_former_names",
                                          placeholder: "customer 1 former names here",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer1_former_names"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                      _createElementVNode("div", _hoisted_76, [
                                        _hoisted_77,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[23] || (_cache[23] = ($event: any) => {_ctx.textSearch($event,'ra1');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.customer1_residental_address,
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.customer1_residental_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer1_residental_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer1_residental_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'customer1_residental_address','ra1');},
                                              class: "suggestDivra"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_81),
                                              _createElementVNode("h6", _hoisted_82, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_83, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_80))
                                          }), 128)),
                                          _hoisted_84
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3 || _ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                      _createElementVNode("div", _hoisted_86, [
                                        _hoisted_87,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.customer1_user_dob,
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.customer1_user_dob) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer1_user_dob",
                                          type: "date",
                                          rules: _ctx.requiredField,
                                          onclick: "this.type='date'",
                                          onfocus: "this.type='date';",
                                          onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                          placeholder: "D.O.B"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer1_user_dob"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3 || _ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                      _createElementVNode("div", _hoisted_89, [
                                        _hoisted_90,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.customer2_full_name,
                                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.customer2_full_name) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer2_full_name",
                                          placeholder: "Second customer name here",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer2_full_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3 || _ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                      _createElementVNode("div", _hoisted_92, [
                                        _hoisted_93,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.customer2_former_names,
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.customer2_former_names) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer2_former_names",
                                          placeholder: "Second customer's  former names here",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer2_former_names"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                      _createElementVNode("div", _hoisted_95, [
                                        _hoisted_96,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[28] || (_cache[28] = ($event: any) => {_ctx.textSearch($event,'ra2');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.customer2_residental_address,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.customer2_residental_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer2_residental_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer2_residental_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_97, [
                                        _createElementVNode("div", _hoisted_98, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'customer2_residental_address','ra2');},
                                              class: "suggestDivra"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_100),
                                              _createElementVNode("h6", _hoisted_101, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_102, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_99))
                                          }), 128)),
                                          _hoisted_103
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3 || _ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                      _createElementVNode("div", _hoisted_105, [
                                        _hoisted_106,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.customer2_user_dob,
                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.customer2_user_dob) = $event)),
                                          class: "form-control selected-field",
                                          name: "customer2_user_dob",
                                          type: "date",
                                          rules: _ctx.requiredField,
                                          onclick: "this.type='date'",
                                          onfocus: "this.type='date';",
                                          onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                          placeholder: "D.O.B"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "customer2_user_dob"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                      _createElementVNode("div", _hoisted_108, [
                                        _hoisted_109,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[31] || (_cache[31] = ($event: any) => {_ctx.textSearch($event,'ra');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.residental_address,
                                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.residental_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "residental_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "residental_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_110, [
                                        _createElementVNode("div", _hoisted_111, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'residental_address','ra');},
                                              class: "suggestDivra"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_113),
                                              _createElementVNode("h6", _hoisted_114, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_115, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_112))
                                          }), 128)),
                                          _hoisted_116
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_117, [
                                  _createElementVNode("div", _hoisted_118, [
                                    _hoisted_119,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_currency,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.investment_currency) = $event)),
                                      class: "form-control",
                                      name: "investment_currency",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_120,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.currency) + " - " + _toDisplayString(country.country_name), 9, _hoisted_121))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_currency"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_122, [
                                  _createElementVNode("div", _hoisted_123, [
                                    _hoisted_124,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_amount,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.investment_amount) = $event)),
                                      class: "form-control",
                                      name: "investment_amount",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_125,
                                        _hoisted_126,
                                        _hoisted_127,
                                        _hoisted_128
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_amount"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_129, [
                                  _createElementVNode("div", _hoisted_130, [
                                    _hoisted_131,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.applicant_country,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.applicant_country) = $event)),
                                      class: "form-control",
                                      name: "applicant_country",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_132,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.country_name), 9, _hoisted_133))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "applicant_country"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_134, [
                          _createElementVNode("div", _hoisted_135, [
                            _createElementVNode("div", _hoisted_136, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_137, [
                              _createElementVNode("button", {
                                onClick: _cache[37] || (_cache[37] = ($event: any) => {_ctx.next_step=1;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("button", {
                                onClick: _cache[38] || (_cache[38] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==2)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 1,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_139, [
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, [
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("div", _hoisted_143, [
                                (_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                      _createElementVNode("div", _hoisted_145, [
                                        _hoisted_146,
                                        _createVNode(_component_Field, {
                                          onChange: _cache[39] || (_cache[39] = ($event: any) => {_ctx.conditionChange();}),
                                          modelValue: _ctx.form.individual_nature,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.individual_nature) = $event)),
                                          class: "form-control",
                                          name: "individual_nature",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_147,
                                            _hoisted_148,
                                            _hoisted_149
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "individual_nature"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                      _createElementVNode("div", _hoisted_151, [
                                        _hoisted_152,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.business_name,
                                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.business_name) = $event)),
                                          class: "form-control selected-field",
                                          name: "business_name",
                                          placeholder: "ie. Business Name under which business is carried out:",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "business_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                      _createElementVNode("div", _hoisted_154, [
                                        _hoisted_155,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[42] || (_cache[42] = ($event: any) => {_ctx.textSearch($event,'_pr_a');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.principal_address,
                                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.principal_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "principal_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "principal_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_156, [
                                        _createElementVNode("div", _hoisted_157, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'principal_address','_pr_a');},
                                              class: "suggestDiv_pr_a"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_159),
                                              _createElementVNode("h6", _hoisted_160, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_161, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_158))
                                          }), 128)),
                                          _hoisted_162
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_nature==1 && _ctx.form.individual_customer_type==5)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                      _createElementVNode("div", _hoisted_164, [
                                        _hoisted_165,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.individual_ABN,
                                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.individual_ABN) = $event)),
                                          class: "form-control selected-field",
                                          name: "individual_ABN",
                                          placeholder: "ie. ABN here",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "individual_ABN"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                ((_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5) && _ctx.form.individual_nature==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                      _createElementVNode("div", _hoisted_167, [
                                        _hoisted_168,
                                        _createTextVNode(),
                                        _hoisted_169,
                                        _createVNode(_component_Field, {
                                          id: "usa_citizen0",
                                          modelValue: _ctx.form.usa_citizen,
                                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.usa_citizen) = $event)),
                                          class: "mx-2",
                                          name: "usa_citizen",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_170,
                                        _createVNode(_component_Field, {
                                          id: "usa_citizen1",
                                          modelValue: _ctx.form.usa_citizen,
                                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.form.usa_citizen) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "usa_citizen",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_171,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "usa_citizen"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                ((_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5) && _ctx.form.individual_nature==2 && (_ctx.form.usa_citizen==1) && (_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                                      _createElementVNode("div", _hoisted_173, [
                                        _hoisted_174,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.social_security_no,
                                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.form.social_security_no) = $event)),
                                          class: "form-control selected-field",
                                          name: "social_security_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "social_security_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                ((_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5) && _ctx.form.individual_nature==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                      _createElementVNode("div", _hoisted_176, [
                                        _hoisted_177,
                                        _createTextVNode(),
                                        _hoisted_178,
                                        _createVNode(_component_Field, {
                                          id: "usa_tax_resident0",
                                          modelValue: _ctx.form.usa_tax_resident,
                                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.usa_tax_resident) = $event)),
                                          class: "mx-2",
                                          name: "usa_tax_resident",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_179,
                                        _createVNode(_component_Field, {
                                          id: "usa_tax_resident1",
                                          modelValue: _ctx.form.usa_tax_resident,
                                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.usa_tax_resident) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "usa_tax_resident",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_180,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "usa_tax_resident"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                ((_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5) && _ctx.form.individual_nature==2 && _ctx.form.usa_tax_resident==1 && (_ctx.form.individual_customer_type==1 || _ctx.form.individual_customer_type==5))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                                      _createElementVNode("div", _hoisted_182, [
                                        _hoisted_183,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.usa_tax_id,
                                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.usa_tax_id) = $event)),
                                          class: "form-control selected-field",
                                          name: "usa_tax_id",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "usa_tax_id"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3 || _ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                      _createElementVNode("div", _hoisted_185, [
                                        _hoisted_186,
                                        _createVNode(_component_Field, {
                                          onChange: _cache[51] || (_cache[51] = ($event: any) => {_ctx.conditionChange();}),
                                          modelValue: _ctx.form.individual_nature1,
                                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.individual_nature1) = $event)),
                                          class: "form-control",
                                          name: "individual_nature1",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_187,
                                            _hoisted_188,
                                            _hoisted_189
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "individual_nature1"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.individual_customer_type==2 || _ctx.form.individual_customer_type==3 || _ctx.form.individual_customer_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                                      _createElementVNode("div", _hoisted_191, [
                                        _hoisted_192,
                                        _createVNode(_component_Field, {
                                          onChange: _cache[53] || (_cache[53] = ($event: any) => {_ctx.conditionChange();}),
                                          modelValue: _ctx.form.individual_nature2,
                                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.individual_nature2) = $event)),
                                          class: "form-control",
                                          name: "individual_nature2",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_193,
                                            _hoisted_194,
                                            _hoisted_195
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "individual_nature2"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_196, [
                          _createElementVNode("div", _hoisted_197, [
                            _createElementVNode("div", _hoisted_198, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_199, [
                              _createElementVNode("button", {
                                onClick: _cache[56] || (_cache[56] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_200, [
                              _createElementVNode("button", {
                                onClick: _cache[57] || (_cache[57] = ($event: any) => {_ctx.next_step=3;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Banks, {
                    key: 2,
                    token: _ctx.token,
                    amad: _ctx.amad,
                    countries: _ctx.countries,
                    current_step: _ctx.current_step,
                    load_on: _ctx.load_on
                  }, null, 8, ["token", "amad", "countries", "current_step", "load_on"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 3,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_201, [
                        _hoisted_202,
                        _createElementVNode("div", _hoisted_203, [
                          _createElementVNode("div", _hoisted_204, [
                            _createElementVNode("div", _hoisted_205, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_206, [
                              _createElementVNode("button", {
                                onClick: _cache[59] || (_cache[59] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==4)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 4,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_207, [
                        _createElementVNode("div", _hoisted_208, [
                          _createElementVNode("div", _hoisted_209, [
                            _createElementVNode("div", _hoisted_210, [
                              _createElementVNode("div", _hoisted_211, [
                                _createElementVNode("div", _hoisted_212, [
                                  _createElementVNode("div", _hoisted_213, [
                                    _hoisted_214,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_name,
                                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.form.esign_name) = $event)),
                                      placeholder: "i.e. Jonaten ",
                                      class: "form-control selected-field",
                                      name: "esign_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_215, [
                                  _createElementVNode("div", _hoisted_216, [
                                    _hoisted_217,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_email_id,
                                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.form.esign_email_id) = $event)),
                                      placeholder: "i.e. email@address.com  ",
                                      class: "form-control selected-field",
                                      name: "esign_email_id",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.validateEmail]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_email_id"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_218, [
                                  _createElementVNode("div", _hoisted_219, [
                                    _hoisted_220,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_phone_no,
                                      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.form.esign_phone_no) = $event)),
                                      placeholder: "i.e. 3539 000556  ",
                                      class: "form-control selected-field",
                                      name: "esign_phone_no",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.mobileField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_phone_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_221, [
                                  _createElementVNode("div", _hoisted_222, [
                                    _hoisted_223,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_dob,
                                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.form.esign_dob) = $event)),
                                      class: "form-control selected-field",
                                      name: "esign_dob",
                                      type: "date",
                                      rules: _ctx.requiredField,
                                      onclick: "this.type='date'",
                                      onfocus: "this.type='date';",
                                      onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                      placeholder: "D.O.B"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_dob"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_224, [
                          _createElementVNode("div", _hoisted_225, [
                            _createElementVNode("div", _hoisted_226, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_227, [
                              _createElementVNode("button", {
                                onClick: _cache[65] || (_cache[65] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_228, [
                              _createElementVNode("button", {
                                onClick: _cache[66] || (_cache[66] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==5  && _ctx.final_step==5)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 5,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_229, [
                        _createElementVNode("div", _hoisted_230, [
                          _createElementVNode("div", _hoisted_231, [
                            _createElementVNode("div", _hoisted_232, [
                              _createElementVNode("div", _hoisted_233, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.final_docs, (upload_doc) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "col-md-12 col-12",
                                    key: upload_doc.input_name
                                  }, [
                                    _createElementVNode("div", _hoisted_234, [
                                      _createElementVNode("label", _hoisted_235, _toDisplayString(upload_doc.name), 1),
                                      _hoisted_236,
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 0,
                                            onChange: _cache[67] || (_cache[67] = ($event: any) => (_ctx.uploadFile($event))),
                                            class: "form-control selected-field",
                                            name: "{{upload_doc.input_name}}",
                                            type: "file"
                                          }))
                                        : _createCommentVNode("", true),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']=='undefined' || _ctx.records[upload_doc.input_name+'_url']=='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 1,
                                            onChange: _cache[68] || (_cache[68] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form[upload_doc.input_name],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name]) = $event),
                                            class: "form-control selected-field",
                                            name: upload_doc.input_name,
                                            type: "file",
                                            rules: _ctx.requiredField
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "rules"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name
                                      }, null, 8, ["name"]),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: "p-cursor",
                                            onClick: ($event: any) => {_ctx.openDoc(_ctx.records[upload_doc.input_name+'_url']);}
                                          }, [
                                            _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_238),
                                            _createTextVNode(" " + _toDisplayString(upload_doc.name), 1)
                                          ], 8, _hoisted_237))
                                        : _createCommentVNode("", true),
                                      (_ctx.form[upload_doc.input_name+'_pdiv']==1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                                            _createElementVNode("div", {
                                              class: "progress-bar bg-dark",
                                              role: "progressbar",
                                              style: _normalizeStyle({'width':_ctx.form[upload_doc.input_name+'_pbar']+'%'}),
                                              "aria-valuenow": _ctx.form[upload_doc.input_name+'_pbar'],
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }, _toDisplayString(_ctx.form[upload_doc.input_name+'_pbar_p']), 13, _hoisted_240)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_Field, {
                                        rules: _ctx.requiredField,
                                        modelValue: _ctx.form[upload_doc.input_name+'_path'],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name+'_path']) = $event),
                                        class: "form-control selected-field",
                                        name: upload_doc.input_name+'_path',
                                        type: "hidden"
                                      }, null, 8, ["rules", "modelValue", "onUpdate:modelValue", "name"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name+'_path'
                                      }, null, 8, ["name"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_241, [
                          _createElementVNode("div", _hoisted_242, [
                            _createElementVNode("div", _hoisted_243, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_244, [
                              _createElementVNode("button", {
                                onClick: _cache[70] || (_cache[70] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_245, [
                              _createElementVNode("button", {
                                onClick: _cache[71] || (_cache[71] = ($event: any) => {_ctx.next_step=200;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Finish ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_246, [
      _createElementVNode("div", _hoisted_247, [
        _createElementVNode("div", _hoisted_248, [
          _createElementVNode("div", _hoisted_249, [
            _createElementVNode("div", _hoisted_250, [
              _hoisted_251,
              _createElementVNode("div", _hoisted_252, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.cancel_request(2)))
                }, "Ok"),
                _createElementVNode("button", {
                  onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.closeModal('cancel_request'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}